import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=4777d74f&scoped=true"
import script from "./CreateTournament.vue?vue&type=script&lang=js"
export * from "./CreateTournament.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateTournament.vue?vue&type=style&index=1&id=4777d74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777d74f",
  null
  
)

export default component.exports